import React from "react";
import PropTypes from "prop-types";
import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax';

const Header = (props) => {

  const background: BannerLayer = {
    image:
      '/images/mexico-sunset-bg-04.jpg',
    translateY: [0, 50],
    opacity: [1, 0],
    scale: [1, 1.05, 'easeOutCubic'],
    shouldAlwaysCompleteAnimation: true,
  };

  const headline: BannerLayer = {
    translateY: [0, -10],
    opacity: [1, 0],
    shouldAlwaysCompleteAnimation: true,
    expanded: true,
    children: (
      <div className="top">
        <h1><span className="theStory">The story of</span>Ilze Bilze</h1>
      </div>
    ),
  };

  const foreground: BannerLayer = {
    image:
      '/images/mexico-sunset-palms-04.png',
    translateY: [0, 20],
    opacity: [1, 0],
    scale: [1, 1.2, 'easeOutCubic'],
    shouldAlwaysCompleteAnimation: true,
  };

  const paragraph: BannerLayer = {
    translateY: [0, 60],
    opacity: [0, 1],
    scale: [1, 1.05, 'easeOutCubic'],
    shouldAlwaysCompleteAnimation: true,
    expanded: false,
    children: (
      <div className="paragraph">
        <h2 className="tagline">
          <span>{props.tagline}</span>
        </h2>
        <p>I found my happy place the day I stopped comparing myself to everyone else and just embraced that I'm strange as fuck and oddly out of place and I kinda dig it that way. My weirdness is my magic. - Brook Hampton -</p>
      </div>
    ),
  };
  
  const gradientOverlay: BannerLayer = {
    opacity: [0, 2],
    shouldAlwaysCompleteAnimation: true,
    expanded: false,
    children: (
      <div className="absolute bg-gradient" />
    ),
  };

  return (
    <header className="header">
      <ParallaxProvider>
        <ParallaxBanner
          layers={[background, headline, foreground, gradientOverlay, paragraph]}
          className="block aspect-[2/1]"
        />
      </ParallaxProvider>
    </header>
  );
};

Header.propTypes = {
  tagline: PropTypes.string.isRequired
};

export default Header;